<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    fill-rule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      d="M12.4874 0V1.87957H7.51257V0.00143369H3.53499V1.87957H0V20H20V1.87814H16.4621V0.00143369H12.4889L12.4874 0ZM2.23595 17.8351H17.7655V6.45591H2.23452V17.8323L2.23595 17.8351Z"
    ></path>
    <path d="M3.53643 11.2459H7.51114V7.64444H3.535L3.53643 11.2459Z"></path>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'CalendarSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
